import { render, staticRenderFns } from "./kutabs.vue?vue&type=template&id=1f2ac418&scoped=true"
import script from "./kutabs.vue?vue&type=script&lang=js"
export * from "./kutabs.vue?vue&type=script&lang=js"
import style0 from "./kutabs.vue?vue&type=style&index=0&id=1f2ac418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ac418",
  null
  
)

export default component.exports